import React from 'react';
import {useSelector} from 'react-redux';
import {getElection} from '../../../features/election/store/selectors';
import logo from './logo.png';

interface ILogoSize {
  height?: number;
  width?: number;
}

const Logo: React.FC<ILogoSize> = ({height, width}) => {
  const election = useSelector(getElection);

  if (!election) {
    return (
      <img
        src={logo}
        style={{
          height: height ? height : 'auto',
          width: width ? width : 'auto',
        }}
        alt="Sei Pocket Eleições"
      />
    );
  }

  return (
    <img
      src={election._thumb_src}
      style={{
        height: height ? height : 'auto',
        width: width ? width : 'auto',
      }}
      alt={`Sei Pocket Eleições - ${election.name}`}
    />
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/shared/components/Logo/Logo.tsx